import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';
import { ISetNameParams } from '~src/spacesPlatform/utils/actionParams';

export class RenameViewRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('renameView', {
      id: id,
      name: name
    });
  }
}
